import { Button } from '@heidi/design-system/button';
import { FramedIcon } from '@heidi/design-system/framed-icon';
import { TypographyCaptionBold, TypographyP2Bold } from '@heidi/design-system/typography';
import { useTranslations } from '@heidi/runtime/i18n';
import { RefreshCw } from 'lucide-react';

type EhrSessionErrorResultProps = {
  onRetry: () => void;
};

const EhrSessionErrorResult = ({ onRetry }: EhrSessionErrorResultProps) => {
  const { t } = useTranslations();
  return (
    <>
      <FramedIcon size="lg" state="error" />
      <TypographyP2Bold className="text-validation-destructive">
        {t('sessions.errorLoadingSessions')}
      </TypographyP2Bold>
      <Button disableAutomaticSvgSizing size="xs" onClick={onRetry} className="w-[70px]">
        <RefreshCw size={12} className="min-h-3 min-w-3" />
        <TypographyCaptionBold>{t('sessions.retry')}</TypographyCaptionBold>
      </Button>
    </>
  );
};

export default EhrSessionErrorResult;
